import { createApp } from '@wu/widget-core';
import { StoreLocator } from './store-locator';

export default createApp(
  { alias: 'store-locator', name: 'Store Locator' },
  StoreLocator
);
